import React, { Component } from 'react';
import { do_action } from '../../actions';
import {BASE_URL_ADMIN} from '../../data/config'

class ModalUpdatePriceItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            price: '',
            old_price: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.nb_click !== this.props.nb_click || nextProps.item != this.props.items) {
            this.setState({
                price: nextProps.item.price,
                old_price: nextProps.item.price
            });
        }
    }

    handleInput(e) {
        this.setState({
            price: e.target.value
        });
    }

    submitUpdatePrice(e) {
        e.preventDefault();
        let {item, vendor} = this.props;
        let {price} = this.state;

        do_action('update_price_item_vendor', { vendor_id: vendor._id, price, item_id: item._id })
            .then(data => {
                if (data.signal) {
                    let $ = window.$;
                    $('#modal-update-price').modal('hide');
                    this.setState({
                        old_price: price
                    })
                    this.props.updatePrice(item._id, price);
                }
            })
            .catch(err => console.log(err));
    }

    render() {
        let {item} = this.props;
        let {price, old_price} = this.state;

        let imageUrl =  (item && item.image_path) ? BASE_URL_ADMIN + '/uploads/' + item.image_path : '/images/re1.png';
        let itemName = item ? item.title : '';

        return (

            <div className="modal fade" id="modal-update-price" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog" role="document">

                    <div className="modal-ruhu">
                        <div className="mdr-title">
                            <div className="text">Update Price</div>
                            <a href="#" data-dismiss="modal" className="closeX">
                                <img src="/images/icon-close.png" alt=""/>
                            </a>
                        </div>
                        {item && (
                            <div className="mdr-content">
                                <div className="form-group">
                                    <div className="clearfix vendor-item-update-modal">
                                        <div className="pull-left img">
                                            <img src={imageUrl} alt="" className="img-responsive"/>
                                        </div>
                                        <div className="info">
                                            <div className="name">{itemName}</div>
                                            <div className="text-primary-kt fontSemiBold">{`$${old_price}/${item.type_price}`}</div>
                                        </div>
                                        <span className="icon-right fa fa-angle-right" role="button" onClick={this.props.nextItem}></span>
                                    </div>
                                </div>
                                <p className="fontMedium tit">New Price</p>
                                <div className="form-group">
                                    <input type="number" className="form-control form-control-mix" placeholder="Enter price..." value={price} onChange={this.handleInput.bind(this)} />
                                </div>
                                <div className="form-group">
                                    <a href="#" className="bg-blue btn-block text-center btn-blue" onClick={this.submitUpdatePrice.bind(this)}>Update</a>
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        );
    }
}

export default ModalUpdatePriceItems;